import Vue from "vue";
import { ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/modules/general/types";
import { AxiosResponse } from "axios";
import { API_PEDIDO } from "./types";

type FinalizarPedidoContext = ActionContext<API_PEDIDO, RootState>;
type FinalizarPedidoActionTree = ActionTree<API_PEDIDO, RootState>;

export const actions: FinalizarPedidoActionTree = {


  async listarDirecciones(context: FinalizarPedidoContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Pedido/ListarDirecciones",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },

  async obtenerContacto(context: FinalizarPedidoContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "GET",
        url: "/Pedido/obtenerContacto",
        params: payload,
      });
      return response.data;
    } catch (error) {
      //Vacio, porque puede venir cualquier cosa.. :D
    }
  },



  async servirPedido(context: FinalizarPedidoContext, payload: any): Promise<any> {
    try {
      const response: AxiosResponse = await Vue.axios({
        method: "POST",
        url: "/Pedido/GenerarPedido",
        data: payload,
      });
      console.log(response);
      return true;
    } catch (error) {
      console.log(error);
      return false;
    }
  },


};
